import { create } from "zustand";

import {
  DefaultListResponse,
  DefaultPageState,
} from "../../../../common/models/StoreDefaultModel";
import { ActionsKey } from "../../../../common/models/Actions";
import { DamagedTypeDataModel } from "../../damagedType/core/_model";

export const initialPageState: DefaultPageState = {
  page: 1,
  itemsPerPage: 10,
};

export type ActionedMissingMaterial = {
  data: DamagedTypeDataModel | null;
  action: ActionsKey;
};

type DamagedTypeDataType = {
  list: any;
  pageState: any;
  detail: DamagedTypeDataModel | null;
  actioned: ActionedMissingMaterial | null;
  totalItems?: number;
  setPageState: (detail: any | null) => void;
  setDetail: (detail: DamagedTypeDataModel | null) => void;
  setList: (roles: DefaultListResponse | null) => void;
  setActioned: (act: ActionedMissingMaterial | null) => void;
  resetPageState: () => void;
};

export const useDamagedTypeStore = create<DamagedTypeDataType>((set) => ({
  list: [],
  detail: null,
  actioned: null,
  pageState: initialPageState,

  totalItems: 0,
  setPageState: (pageState) => set((state) => ({ pageState })),
  resetPageState: () =>
    set(() => ({
      pageState: initialPageState,
    })),
  setDetail: (detail) => set((state) => ({ detail })),
  setList: (data) =>
    set((state) => ({
      list: data?.member,
      totalItems: data?.totalItems,
    })),
  setActioned: (act) => set((state) => ({ actioned: act } as any)),
}));
